import { NavigationBack, Typography } from "@/components";
import FloatingSearchV2 from "@/components/ui/floating-search/v2";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { useLocation, useNavigate, useSearch } from "@tanstack/react-router";
import { useCallback } from "react";

const AppBarInbox = () => {
	const searchQ = useSearch({
		strict: false,
		select: (s) => s.q || "",
	});
	const isReminder = useLocation({
		select: (s) => s.pathname === "/dashboard/inbox/reminders",
	});
	const navigate = useNavigate();

	const onChangeSearch = useCallback(
		(value: string) =>
			navigate({
				search: {
					// @ts-expect-error
					q: value || undefined,
				},
				replace: true,
			}),
		[navigate],
	);

	return (
		<AppBar
			position="relative"
			color="transparent"
			className="[&_*_]:text-white !bg-gradient-contact"
		>
			<div className="container">
				<Toolbar classes={{ root: "!p-0" }}>
					{isReminder ? <NavigationBack /> : null}
					<div className="w-full relative flex gap-1 justify-between py-3">
						<FloatingSearchV2
							name="search"
							value={searchQ}
							onClear={() => onChangeSearch("")}
							onChange={(e) => onChangeSearch(e.target.value)}
							className="!rounded-xl"
							inputClassName="!rounded-xl"
						>
							<div className="flex items-center">
								<Typography fontWeight={700} fontSize={16}>
									{!isReminder ? "Inbox" : "To-Do List"}
								</Typography>
							</div>
						</FloatingSearchV2>
					</div>
				</Toolbar>
			</div>
		</AppBar>
	);
};
export default AppBarInbox;
